import React from "react";

// Classname
import clsx from "clsx";

// Lib
import { useAppDispatch } from "lib/hooks/useDispatch";

// Actions
import * as actionsCreator from "../reducer";

// Type
import { TAlhabet } from "../type";

// Interface
interface IAlphabet {
  data?: TAlhabet[];
  className?: string;
  outerDisable?: boolean;
  currentLetter?: string;
}

export const Alphabet: React.FC<IAlphabet> = (props) => {
  const dispatch = useAppDispatch();

  const { data, className = "", outerDisable = false, currentLetter } = props;

  const handlerChangeWord = (letter: string) => () => {
    if (!outerDisable) {
      dispatch(actionsCreator.handlerChangeLetter(letter));
    }
  };

  const cnWrapper = clsx(
    "alphabet flex flex-ai-center flex-jc-start",
    className ? className : "",
    outerDisable ? "alphabet--active" : ""
  );

  const getList = (data: TAlhabet[]) => {
    return data.map((item: TAlhabet) => {
      const cn = clsx(
        "alphabet__letter flex flex-ai-center flex-jc-center",
        item.letter === currentLetter ? "alphabet__letter--active" : ""
      );
      return <div
        className={cn}
        key={item.letter}
        onClick={handlerChangeWord(item.letter)}
        title={`Total amount of impurities: ${item.count}`}
      >
        {item.letter}
      </div>;
    });
  };

  return (
    <div className={cnWrapper}>
      {getList(data || [])}
    </div>
  );
};

export default Alphabet;
